import api from '@/api'
import {
  SET_CLIENT_PROMOTION_NOTICE_LIST,
  // SET_CLIENT_PROMOTION_NOTICE_LIST_PAGE,
  // SET_CLIENT_PROMOTION_NOTICE_LIST_PAGE_SIZE_TOTAL,
  SET_CLIENT_PROMOTION_NOTICE_LIST_PAGE_COUNT,
  SET_CLIENT_PROMOTION_NOTICE_LIST_TOTAL,
  SET_CLIENT_PROMOTION_NOTICE_LIST_PAGE_SIZE,
  // SET_SCROLL_DISABLE,
  // RESET_CLIENT_PROMOTION_NOTICE_LIST,
} from './mutation-types'

const state = {
  pageSize: 20,
  pageCount: 0,
  total: 0,
  noticeList: [],
  // clientPromotionNoticeList: {
  //   list: [],
  //   listCurrentPage: 1,
  //   listPageTotal: 0,
  //   listPageSize: 10,
  //   listPageCount: 1,
  // },
  // scrollDiable: true,
}

const mutations = {
  [SET_CLIENT_PROMOTION_NOTICE_LIST] (state, payload) {
    state.noticeList = payload
    // if (payload.payload.type && payload.payload.type === 'refresh') {
    //   state.noticeList = payload.items
    // } else {
    //   state.noticeList = [...state.clientPromotionNoticeList.list, ...payload.items]
    // }
  },
  // [RESET_CLIENT_PROMOTION_NOTICE_LIST](state) {
  //   state.clientPromotionNoticeList.list = []
  // },
  // [SET_CLIENT_PROMOTION_NOTICE_LIST_PAGE](state, payload) {
  //   state.clientPromotionNoticeList.listCurrentPage = payload
  // },
  // [SET_CLIENT_PROMOTION_NOTICE_LIST_PAGE_SIZE_TOTAL] (state, payload) {
  //   state.clientPromotionNoticeList.listPageTotal = payload
  // },
  [SET_CLIENT_PROMOTION_NOTICE_LIST_PAGE_COUNT] (state, payload) {
    state.pageCount = payload
  },
  [SET_CLIENT_PROMOTION_NOTICE_LIST_PAGE_SIZE] (state, payload) {
    state.pageSize = payload
  },
  [SET_CLIENT_PROMOTION_NOTICE_LIST_TOTAL] (state, payload) {
    state.total = payload
  },
  // [SET_SCROLL_DISABLE] (state, payload) {
  //   state.scrollDiable = payload
  // },
}

const actions = {
  // 获取客户端推广通知列表
  async getClientPromotionNoticeList ({state, commit}, payload) {
    // commit(SET_SCROLL_DISABLE, true)
    let params = {
      pageSize: payload.pageSize,
      pageNum: payload.pageNum,
      noticeTitle: payload.noticeTitle,
      startTime: payload.startTime,
      endTime: payload.endTime,
    }
    try {
      const {data: {items, pageCount, total}} = await api.deployApi.getClientNoticeList(params)
      if (payload.type === 'scrollAdd') {
        commit(SET_CLIENT_PROMOTION_NOTICE_LIST, [...state.noticeList, ...items])
      } else {
        commit(SET_CLIENT_PROMOTION_NOTICE_LIST, items)
      }
      // commit(SET_CLIENT_PROMOTION_NOTICE_LIST, { items: items, payload: payload })
      // commit(SET_CLIENT_PROMOTION_NOTICE_LIST_PAGE_SIZE_TOTAL, total)
      commit(SET_CLIENT_PROMOTION_NOTICE_LIST_PAGE_COUNT, pageCount)
      commit(SET_CLIENT_PROMOTION_NOTICE_LIST_TOTAL, total)
    } catch (error) {
      commit(SET_CLIENT_PROMOTION_NOTICE_LIST, [])
      // commit(SET_CLIENT_PROMOTION_NOTICE_LIST_PAGE_SIZE_TOTAL, 1)
      commit(SET_CLIENT_PROMOTION_NOTICE_LIST_PAGE_COUNT, 0)
    }
    // commit(SET_SCROLL_DISABLE, false)
  },
  // async changeListPage({ commit, state, dispatch }, payload) {
  //   commit(SET_CLIENT_PROMOTION_NOTICE_LIST_PAGE, payload.currentPage)
  //   dispatch('setClientPromotionNoticeList', payload)
  // },
  refreshClientPromotionList ({dispatch}) {
    dispatch('getClientPromotionNoticeList', {pageNum: 1, pageSize: state.pageSize, type: 'refresh'})
  },
  updatePageSize({ commit }, payload) {
    commit(SET_CLIENT_PROMOTION_NOTICE_LIST_PAGE_SIZE, payload)
  },
  // initClientPromotionNoticeList ({ commit, dispatch }, payload) {
  //   dispatch('changeListPage', { currentPage: 1 })
  // },
  // 新增客户端推广通知
  async addClientPromotionNotice ({dispatch}, payload) {
    const result = await api.deployApi.addClientNotice(payload)
    dispatch('refreshClientPromotionList')
    // dispatch('changeListPage', { currentPage: 1, type: 'refresh' })
    return result
  },
  // 编辑客户端推广通知
  async editClientPromotionNotice ({ dispatch }, payload) {
    const result = await api.deployApi.updateClientNotice(payload)
    dispatch('refreshClientPromotionList')
    // dispatch('changeListPage', { currentPage: 1, type: 'refresh' })
    return result
  },
  // 删除客户端推广通知
  async deleteClientPromotionNotice ({ dispatch }, payload) {
    const result = await api.deployApi.deleteClientNotice(payload)
    dispatch('refreshClientPromotionList')
    // dispatch('changeListPage', { currentPage: 1, type: 'refresh' })
    return result
  },
  // 客户端版本（王顺辉）
  async getClientChannel ({ dispatch }) {
    const result = await api.deployApi.getClientChannel()
    return result
  },
  // 重置客戶端推廣通知
  // resetClientNotice({ commit }) {
  //   commit(RESET_CLIENT_PROMOTION_NOTICE_LIST)
  // },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
